import React, { useEffect, useState } from "react";
import {
  Button,
  CreateButton,
  DeleteButton,
  EditButton,
} from "../../../common/components/ant/button";
import Portal from "../../../common/components/portal";
import {
  createOrganization,
  getOrganizationDetails,
  updateOrganization,
  setSelectedOrg,
  getOrganizations,
} from "../../orgActions";
import { useOrganizations, useSelectedOrgId } from "../../orgState";
import { initialOrgValues, OrganizationDeatils } from "../../orgTypes";
import OrgActions from "./orgActions";
import { useTranslation } from "react-i18next";
import {
  CaretDownOutlined,
  CaretUpOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import { roleTypes } from "../../../users/userType";
import { RoleChecker } from "../../../utils/roleChecker";
import { FormInstance, List, notification, Space } from "antd";
import { handleErrors } from "../../../utils/validation";
import { confirm } from "../../../common/components/ant/modal";
import { useLoggedInUser } from "../../../auth/authState";
import { deleteOrganization } from "../../orgService";

interface DetailsProps {
  showDetails: any;
}
const Details: React.FC<DetailsProps> = ({ showDetails }) => {
  const selectedOrgId = useSelectedOrgId();
  const organizations = useOrganizations();
  const organization = organizations.byId[selectedOrgId];
  const defaultOrgId = useLoggedInUser().primaryOrgId;

  const [showOrgDetails, setShowOrgDetails] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [parentId, setParentId] = useState(0);
  const [title, setTitle] = useState("");

  const { t } = useTranslation();

  const handleCancel = () => {
    setShowModal(false);
    setParentId(0);
  };

  const handleSubmit = (values: OrganizationDeatils, form: FormInstance) => {
    if (parentId) {
      values = {
        ...values,
        parentId: selectedOrgId,
        parentCode: organization.code,
      };
      createOrganization(values)
        .then(() => handleCancel())
        .catch((error) => {
          handleErrors(error.response.data, t, form, handleCancel);
        });
    } else {
      updateOrganization(values, selectedOrgId)
        .then(() => handleCancel())
        .catch((error) => {
          handleErrors(error.response.data, t, form, handleCancel);
        });
    }
  };

  const handleSubmitDelete = () => {
    deleteOrganization(selectedOrgId)
      .then(() => {
        notification.success({
          message: t("organizations.actions.deleteSuccess"),
        });
        return getOrganizations();
      })
      .then(() =>
        setSelectedOrg(defaultOrgId ? defaultOrgId : organizations.allIds[0])
      )
      .catch((err) => {
        notification.error({
          message: (
            <List
              dataSource={
                err?.response?.data?.fieldErrors.map(
                  (err: { message: string; code: string }) => err.message
                ) || []
              }
              renderItem={(item: string) => <List.Item>{item}</List.Item>}
            />
          ),
        });
      });
  };

  useEffect(() => {
    if (selectedOrgId) {
      getOrganizationDetails(selectedOrgId);
    }
  }, [selectedOrgId]);

  const showConfirm = () => {
    confirm({
      title: t("organizations.deleteMessage"),
      icon: <ExclamationCircleOutlined />,
      onOk() {
        handleSubmitDelete();
      },
    });
  };

  return (
    <>
      <Portal selectorId="create-root-container">
        <div
          className="dropdown-item"
          onClick={() => {
            setShowModal(true);
            setTitle(t("organizations.actions.newRootOrgTitle"));
          }}
        >
          {t("organizations.actions.newRootOrg")}
        </div>
      </Portal>

      <OrgActions
        showModal={showModal}
        handleCancel={handleCancel}
        handleSubmit={handleSubmit}
        initialValues={parentId ? initialOrgValues : organization}
        title={title}
      />

      {organization && (
        <div className="details-container">
          <Portal selectorId="create-child-container">
            <Space>
              <CreateButton
                onClick={() => {
                  setShowModal(true);
                  setTitle(t("organizations.actions.newChildOrgTitle"));
                  setParentId(selectedOrgId);
                }}
                text={t("organizations.actions.newChildOrg")}
              />
              <DeleteButton
                onClick={() => showConfirm()}
                text={t("organizations.actions.deleteOrganization")}
              />
            </Space>
          </Portal>
          <Portal selectorId="org-details-container">
            <Button
              className="info"
              onClick={() => {
                setShowOrgDetails(!showOrgDetails);
                showDetails(!showOrgDetails);
              }}
            >
              {showOrgDetails ? (
                <>
                  <CaretUpOutlined /> {t("common.hideDetails")}
                </>
              ) : (
                <>
                  <CaretDownOutlined /> {t("common.showDetails")}
                </>
              )}
            </Button>
            <RoleChecker roles={[roleTypes.ADMIN]}>
              {showOrgDetails && (
                <EditButton
                  style={{ marginLeft: "8px" }}
                  onClick={() => {
                    setTitle(t("organizations.actions.editOrganization"));
                    setShowModal(true);
                  }}
                />
              )}
            </RoleChecker>
          </Portal>
          <div className="org-info-container">
            <div className="box-conatiner">
              <div className="org-data">
                <div className="box">
                  <span className="label">{t("organizations.code")}</span>{" "}
                  <span className="value">{organization.code}</span>
                </div>
              </div>
              <div className="org-data">
                <div className="box">
                  <span className="label">{t("organizations.address")}</span>{" "}
                  <span className="value">{organization.address}</span>
                </div>
                <div className="box">
                  <span className="label">
                    {t("organizations.phoneNumber")}
                  </span>{" "}
                  <span className="value">{organization.phone}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Details;
